<mat-card class="transparent-card">
    <mat-card-header>
        <mat-card-title>Create Team</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="teamGroup" (ngSubmit)="createTeam()">
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Team Name</mat-label>
                <input matInput type="text" [formControl]="teamGroup.controls.nameControl">
            </mat-form-field>                                 
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Tricode</mat-label>
                <input matInput type="text" [formControl]="teamGroup.controls.tricodeControl">
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Competition</mat-label>
                <mat-select [formControl]="teamGroup.controls.competitionControl">
                    <mat-select-trigger>
                        <ng-container *ngIf="getSelectedCompetition(teamGroup.controls.competitionControl.value) as competition">
                            <img class="select-field-logo" [src]="competition.logo || placeholderImage"> {{ competition.name }}
                        </ng-container>
                    </mat-select-trigger>
                    <ng-container *ngFor="let competition of competitions">
                        <mat-option [value]="competition.uid">
                            <img class="select-field-logo" [src]="competition.logo || placeholderImage"> {{ competition.name }}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
            <mat-card-actions>
                <button class="create-button" mat-raised-button type="submit" *ngIf="!isProcessing" [disabled]="!teamGroup.valid" color="primary"><mat-icon>add_box</mat-icon>Create</button>
                <button class="create-button" mat-raised-button type="submit" *ngIf="isProcessing" disabled><mat-spinner></mat-spinner></button>
            </mat-card-actions>
        </form>
    </mat-card-content>
</mat-card>